import {useContext} from 'react';
import {CartContext} from '../../../api/context';
import {List, ListItem, ListItemAvatar, Avatar, ListItemText} from '@mui/material';
import {CartItemPayload} from '../../../api/models';
import {buildCartItemSubtitle} from '../../../common/utils';
import {TextComponent} from '../../RetailerWebScreen/components/TextComponent';

export const CartItemDetailsView = () => {
    const catalogItems = useContext(CartContext)?.getCatalogItems() ?? [];
    const cartItems = Array.from(useContext(CartContext)?.getCart()?.cartItems.values() ?? []);
    return (
        <div>
            <TextComponent variant='h5' content={'Cart Items'} fontWeight={600} />
            <List sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}>
                {cartItems.map((item: CartItemPayload, index: number) => {
                    const catalogItem = catalogItems.find((e) => e.id === item.id);
                    if (catalogItem) {
                        return (
                            <ListItem key={index}>
                                <ListItemAvatar>
                                    <Avatar>
                                        <img src={catalogItem?.image.url} />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={catalogItem.title.text}
                                    secondary={buildCartItemSubtitle(item.price, item.quantity)}
                                />
                            </ListItem>
                        );
                    } else {
                        return <></>;
                    }
                })}
            </List>
        </div>
    );
};
